import { VehicleInfoService } from './../../services/vehicle-info.service';
import { TranslateService } from  '@ngx-translate/core';
import { MaintenancePlanService } from './../../services/maintenance-plan.service';
import { DIMBO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';

// Define date format settings
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-additional-info-dialog-box',
  templateUrl: './additional-info-dialog-box.component.html',
  styleUrls: ['./additional-info-dialog-box.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class AdditionalInfoDialogBoxComponent implements OnInit {

  customerLastName: string;
  customerEmail: string;
  phoneNumber: string;
  registration: string;
  firstRegistrationDate: string;
  currentMileage: string;
  mileageUnit: string;
  isServiceHistory:boolean = false ;
  isServiceHistorycm:boolean = false ;

  maxDate = new Date(); 
  regdplaceholder: any;
  canceltranlation: any;
  oktranlation: any;

  constructor(
    public dialogRef: MatDialogRef<AdditionalInfoDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private cacheService: CacheService,
    private maintenancePlanService: MaintenancePlanService,
    private translationService: TranslateService,
    private vehicleInfoService: VehicleInfoService,
    private dateAdapter: DateAdapter<Date>
    ) {
      this.maxDate.setDate(this.maxDate.getDate());
    //  this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.dateAdapter.setLocale(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL));
     }

  ngOnInit(): void {
    this.phoneNumber='';
    this.customerLastName = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_LAST_NAME) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_LAST_NAME);
    this.customerEmail = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_EMAIL) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_EMAIL);
    this.registration = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_REGISTRATION) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_REGISTRATION);
    this.currentMileage = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE);
    if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)) {
      //this.firstRegistrationDate = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE);
      this.firstRegistrationDate = this.formatDate(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE));
    }
    if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT)) {
      this.mileageUnit = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT);
    }
    if(this.data.isfromSH){
    this.isServiceHistory=this.data.isfromSH;
    this.isServiceHistorycm=this.data.isfromSH;
    }
    this.regdplaceholder=this.translationService.instant('dimbo.i18n.label.firstRegistrationDate');
    this.canceltranlation=this.translationService.instant('dimbo.i18n.button.close');
    this.oktranlation=this.translationService.instant('dimbo.i18n.button.ok');
   // console.log('sf ',this.isServiceHistory);
   this.dateAdapter.setLocale(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL));
   if(!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH)){
    this.currentMileage='0';
    this.mileageUnit=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL);
    this.isServiceHistory=true;
    this.isServiceHistorycm=false;
}
  }

  allowAddService() {

   // console.log('--->firstRegistrationDate: ', this.firstRegistrationDate);
    const formattedDate = _moment(this.firstRegistrationDate).format("YYYY-MM-DD");
   // console.log('formattedDate: ', formattedDate);

    if(this.firstRegistrationDate) {
      const formattedDate = _moment(this.firstRegistrationDate).format("YYYY-MM-DD");  
    }

    // performing validation
    if (this.validateAdditionalInfo(this.customerLastName, this.customerEmail,this.phoneNumber, this.registration, formattedDate, this.currentMileage, this.mileageUnit)) {
      this.data.eventName = 'POPUP_OK';
    //let isCustVerified: boolean;
    let params: any = {
      brand: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CIN_BRAND),
      contractId: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CONTRACT_ID),
      emailId: this.customerEmail.trim(),
      phoneNumber:this.phoneNumber,
      lastName: encodeURIComponent(this.customerLastName.trim()),//encode url
      country: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
      // language: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE_RAW)
      language: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL)
    }

    /* let params: any = {
      brand: 'AP',
      contractId: '623256801',
      emailId: 'testeur.england.peugeot@yopmail.com',
      lastName: 'Peugeot',
      country: 'FR',
      language: 'en-GB'
    } */

   // console.log('params: ', params);

    this.spinner.show();


    this.maintenancePlanService.verifyCustomer(params)
      .subscribe(response => {

       // console.log('customer verify response: ', response);
        if (response.isCustomerVerified) {
          // customer is verified
          this.data.isCustVerified = true;  
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED, true);
          this.toastrService.success(this.translationService.instant('dimbo.i18n.message.CustomerVerificationSuccess'));    
          // Now update vehicle information
          let updateVehiclePayload: any = {
            registrationDate: formattedDate,
            mileageValue: this.currentMileage,
            mileageUnit: this.mileageUnit,
            registration: this.registration
          }
          this.updateVehicleInfo(updateVehiclePayload);
          this.dialogRef.close({ event: this.data })
        } else {
          this.data.isCustVerified = false;
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED, false);
        
          //this.dialogRef.close({ event: this.data });
          let currentRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) - 1;
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT, currentRetryCount);

          if (currentRetryCount < 1) {
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFinalAttempt'), '',{
              timeOut: 50000,
            });
          } else {
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed')+' '+currentRetryCount+this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed1'), '',{
              timeOut: 5000,
            });
          }
          
        }
        this.spinner.hide();
        //this.dialogRef.close({ event: this.data });        
        }, error => {
          if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
            this.spinner.hide();
            this.dialogRef.close({ event: this.data });
            /* this.toastrService.error(this.translationService.translate('dimbo.i18n.message.CustomerVerificationFailed'), '',{
              timeOut: 50000,
            }); */
        } else {
            this.spinner.hide();
            this.dialogRef.close({ event: this.data });
            //this.toastrService.error(this.translationService.translate('dimbo.i18n.message.record.error'), this.translationService.translate('dimbo.i18n.message.toastr.error'));
        }
        }
      );

    } 

    
  }

  // Update vehicle infromation
  updateVehicleInfo(updateVehiclePayload: any) {
    this.vehicleInfoService.updateVehicleInfo(updateVehiclePayload)
    .subscribe(response => {
     // console.log("updateVehicleInfo response: ", response);
      // set vehicle reg info in cache on success
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_REGISTRATION, updateVehiclePayload.registration);
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE, updateVehiclePayload.firstRegistrationDate);
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CURRENT_MILEAGE, updateVehiclePayload.mileageValue);
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT, updateVehiclePayload.mileageUnit);
      
       this.toastrService.success(this.translationService.instant('dimbo.i18n.message.record.success'));       
      }, error => {
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.VehicleInfo.vin'));
      } else {
          this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'));
      }
       
      });
    
    this.dialogRef.close();
  }


  validateAdditionalInfo(customerLastName, customerEmail, phoneNumber, registration, firstRegistrationDate, currentMileage, mileageUnit): boolean {
    // customerLastName validation  !this.isAlphabets(customerLastName)
    if(!customerLastName){
     // console.log('pls enter customerLastName');
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.CustomerLastname'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    } /* else {
      if(!this.isAlphabets(customerLastName.trim())) {
        console.log('pls enter customerLastName');  
        this.toastrService.warning(this.translationService.translate('dimbo.i18n.validation.validCustomerLastname'), this.translationService.translate('dimbo.i18n.message.validation.error'),{
          timeOut: 5000,
        });
        return false;
      }
    } */
//PhoneNumer/ Email mandatory check
if (phoneNumber=="" && customerEmail =="")  {
//console.log('pls enter valid Phone Number/valid email');  
  this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.phoneNumberEmailError'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
    timeOut: 5000,
  });
  return false;
}
    
    // customerPhoneNumber validation
    if (phoneNumber && !this.isAlphaNumeric(phoneNumber) ) {
     // console.log('pls enter valid Phone Number');  
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.phoneNumberError'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    }
    
    // customerEmail validation
    if (customerEmail && !this.validateEmail(customerEmail) ) {
     // console.log('pls enter valid email');  
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.Email'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    }

    // registration validation
    if(!registration){
     // console.log('pls enter registration');
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.registration'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    }
    /* if (registration) {
      if (registration.length === 8) {
        console.log('123...');
        if (!this.isAlphaNumeric(registration)) {
          console.log('pls enter registration ');  
          this.toastrService.warning(this.translationService.translate('dimbo.i18n.validation.registration'), this.translationService.translate('dimbo.i18n.message.validation.error'),{
            timeOut: 5000,
          });
          return false;  
        }
      } else {
        this.toastrService.warning(this.translationService.translate('dimbo.i18n.validation.registration'), this.translationService.translate('dimbo.i18n.message.validation.error'),{
          timeOut: 5000,
        });
        return false;
      }

    } else {
      this.toastrService.warning(this.translationService.translate('dimbo.i18n.validation.registration'), this.translationService.translate('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    } */

    /* if (!this.isAlphaNumeric(registration)) {
      console.log('pls enter registration ');  
      this.toastrService.warning(this.translationService.translate('dimbo.i18n.validation.registration'), this.translationService.translate('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;  
    } */

    // firstRegistrationDate validation
    if (!firstRegistrationDate) {
      //console.log('pls enter registration date');  
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.RegistrationDate'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;  
    }

    // currentMileage
    if (!this.isPositiveInteger(currentMileage)) {
    //  console.log('pls enter CurrentMileage');  
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.CurrentMileage'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;
    }

    // mileageUnit validation
    if (!mileageUnit) {
    //  console.log('pls enter mileageUnit ');  
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.mileageUnit'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
        timeOut: 5000,
      });
      return false;  
    }
    
    return true;

  }

  /* Email id validation DMBR-31 Validation check added for - in domain*/
  validateEmail(email: string): boolean {
    if (/^\w+([\.-]?\w+)+@\w+([\.:-]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/.test(email)) {
      return true; 
    } else {
      return false;
    }   
  }

  isAlphabets(e: any): boolean {
    try {
        if (/^[a-zA-Z\s]*$/.test(e)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    } catch (e) {
    }
  }

  isAlphaNumeric(e: any): boolean {
    try {
        if (/^[a-zA-Z0-9-+\s]*$/.test(e)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    } catch (e) {
    }
  }

  isPositiveInteger(n: any) {
    return /^\d+$/.test(n);
  }

  formatDate(strDate: string): string {
    const dateAr = strDate.split('-');
    const newDateStr = dateAr[2]+'-'+dateAr[1]+'-'+dateAr[0];
    return newDateStr;
  }

  /* close popup */
  close(): void {
    this.data.eventName = 'POPUP_CLOSE';
    this.dialogRef.close({ event: this.data });
  }

}
